module.exports = __webpack_public_path__ + "media/images/logo-inverted-2ec83f32.svg";